'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _count = require('./count');

var _count2 = _interopRequireDefault(_count);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'count',
    all: _count2.default
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/size.js
// module id = 157
// module chunks = 35783957827783